import { createSlice } from "@reduxjs/toolkit";
import getAppointmentStudy from "@custom/rtk-apis/appointment/getStudy";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getAppointmentStudySlice = createSlice({
  name: "getAppointmentStudySlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppointmentStudy.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAppointmentStudy.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getAppointmentStudy.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getAppointmentStudySlice.reducer;
export const { closeModal } = getAppointmentStudySlice.actions;
